import FilterBar, { FilterFieldConfig } from '@/components/FilterBar'
import {
    getResellerStatusFilterOptions,
    getResellerTierFilterOptions,
} from '@/modules/Reseller/constants'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'react'

interface ActiveFiltersProps {
    control: any
    watch: (name: string) => any
    setValue: UseFormSetValue<any>
}

const ActiveFilters: React.FC<ActiveFiltersProps> = ({
    control,
    watch,
    setValue,
}) => {
    const { t } = useTranslation('reseller')

    const filterFields = useMemo(
        (): FilterFieldConfig[] => [
            {
                name: 'status',
                type: 'select',
                label: t('status'),
                options: getResellerStatusFilterOptions(t),
                isQuickFilter: true,
            },
            {
                name: 'tier',
                type: 'select',
                label: t('tier'),
                options: getResellerTierFilterOptions(t),
                isQuickFilter: true,
            },
        ],
        [t]
    )

    return (
        <FilterBar
            control={control}
            watch={watch}
            filterFields={filterFields}
            setValue={setValue}
        />
    )
}

export default ActiveFilters
